<template>
    <span title="私密专题仅代表不可以被搜索，不代表完全无法被别人查看">
        <a-tag  :style="{'margin-left': '5px'}" color="pink">私密</a-tag>
    </span>
</template>
<script>
    export default {

    }
</script>